import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useScrollAnimation, useStaggerAnimation } from "../hooks/useScrollAnimation";
import "./DetailPage.css";

function OnyxAIDetail() {
  const heroRef = useScrollAnimation();
  const featuresRef = useStaggerAnimation(3);
  const stepsRef = useStaggerAnimation(3);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="detail-page" style={{ background: 'linear-gradient(180deg, #000000 0%, #0a0a2a 50%, #1a1a4a 100%)' }}>
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-logo">
          <img src="/images/onyxai_logo.png" alt="OnyxAI Logo" />
          <span>OnyxAI</span>
        </div>
        <div className="navbar-links">
          <Link to="/">Home</Link>
          <Link to="/onyxai/privacy">Privacy Policy</Link>
          <Link to="/onyxai/terms">Terms of Use</Link>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="container">
        <div className="detail-hero">
          <div className="detail-hero-left animate-on-scroll" ref={heroRef}>
            <h1>Turn your selfies<br />into stunning AI art</h1>
            <p>
              OnyxAI is your <strong>virtual photo studio</strong>, powered by advanced AI.
              Upload a selfie and instantly transform it into unique portraits, professional headshots,
              or creative artistic styles. No studio, no photographer — just you and the power of AI.
              Express yourself, explore new looks, and create images worth sharing.
            </p>
            <div className="download-buttons">
              {/* <a href="https://apps.apple.com/tr/app/onyxai-virtual-photo-studio/id6749689978?l=tr" className="download-btn">
                <img src="/images/download_android.png" alt="Google Play" />
              </a> */}
              <a href="https://apps.apple.com/tr/app/onyxai-virtual-photo-studio/id6749689978?l=tr" className="download-btn">
                <img src="/images/download_ios.png" alt="App Store" />
              </a>
            </div>
          </div>
          <div className="detail-hero-right">
            <div className="phone-mockup phone-mockup-left">
              <img src="/images/simulator_screenshot_B88DE5FB-942B-4FDD-92A2-AE2D28032416-1.png" alt="OnyxAI Screenshot 1" />
            </div>
            <div className="phone-mockup phone-mockup-right">
              <img src="/images/simulator_screenshot_A74F7658-8C7B-42A4-9CB5-58B496796B85-1.png" alt="OnyxAI Screenshot 2" />
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container">
        <div className="detail-features">
          <h2>Why Choose OnyxAI?</h2>
          <div className="features-grid" ref={featuresRef}>
            <div className="feature-card stagger-item">
              <h3>AI-Powered Templates</h3>
              <p>Choose from hundreds of professional templates designed by AI to create stunning portraits.</p>
            </div>
            <div className="feature-card stagger-item">
              <h3>Face-Aware Enhancement</h3>
              <p>Advanced AI technology that understands facial features for perfect transformations.</p>
            </div>
            <div className="feature-card stagger-item">
              <h3>Professional Quality</h3>
              <p>Studio-quality results without the studio. Perfect for social media, professional profiles, and more.</p>
            </div>
          </div>
        </div>
      </div>

      {/* How It Works */}
      <div className="container">
        <div className="detail-how-it-works">
          <h2>How It Works</h2>
          <div className="steps-grid" ref={stepsRef}>
            <div className="step stagger-item">
              <div className="step-number">1</div>
              <h3>Upload Your Photo</h3>
              <p>Take a selfie or upload your favorite photo</p>
            </div>
            <div className="step stagger-item">
              <div className="step-number">2</div>
              <h3>Choose a Style</h3>
              <p>Select from our collection of AI-powered templates</p>
            </div>
            <div className="step stagger-item">
              <div className="step-number">3</div>
              <h3>Get Your Result</h3>
              <p>Download your transformed image in seconds</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnyxAIDetail;
